const DEVELOPMENT_ENV = 'development';
const STAGING_ENV = 'staging';
const PRODUCTION_ENV = 'production';
const TEST_ENV = 'test';

const OVER_ENV = process.env.VUE_APP_OVER_ENV;
const chosenEnv = OVER_ENV || STAGING_ENV;

const commonConfig = {
  CLIENT_ID: '0AfeemY6IcN6s69KkMaYm-KvvWXT7UdR0zp3lZvALeU',
  SECRET_ID: 'JpCwWbjMfD-UEajAbFx7WNiH3-DH1K5Pu2jDEuTEe1w',
  SCOPE: 'read write establishment',
  API_ENDPOINT_SHARED: 'https://api.staging.the-secret-society.com/v1/',
  API_ENDPOINT_ADMINS: 'https://api.staging.the-secret-society.com/establishments/v1/',
  isProduction: chosenEnv === PRODUCTION_ENV,
  isStaging: chosenEnv === STAGING_ENV,
  isDevelopment: chosenEnv === DEVELOPMENT_ENV,
  isTest: chosenEnv === TEST_ENV,
};
const config = {
  [DEVELOPMENT_ENV]: {
    ...commonConfig,
    OVER_ENV: DEVELOPMENT_ENV,
  },
  [STAGING_ENV]: {
    ...commonConfig,
    OVER_ENV: STAGING_ENV,
  },
  [PRODUCTION_ENV]: {
    ...commonConfig,
    CLIENT_ID: 'LaGMPLFmaay9VuH1-fdBzHqPbpQwE6Hp7mgFwsHjWLQ',
    SECRET_ID: 'sMfjZ_6tpuJyXaobdAIo_siAwbYPAJax8uqY1MSe2J4',
    SCOPE: 'establishment read write',
    API_ENDPOINT_SHARED: 'https://api.the-secret-society.com/v1/',
    API_ENDPOINT_ADMINS: 'https://api.the-secret-society.com/establishments/v1/',
    OVER_ENV: PRODUCTION_ENV,
  },
  [TEST_ENV]: {
    ...commonConfig,
    API_ENDPOINT_SHARED: 'http://localhost:3006/',
    API_ENDPOINT_ADMINS: 'http://localhost:3006/',
    OVER_ENV: TEST_ENV,
  },
};
const finalConfig = config[OVER_ENV || STAGING_ENV];

module.exports = finalConfig;
